import { ApiConcept, ApiConceptRelation } from 'types/swagger/clarifai-api';
import { postConceptRelations } from 'api-proxy/external/postConceptRelations';

export type CreateNewRelation = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
  subjectConceptId: string;
  objectConcept: ApiConcept;
  predicate?: string;
};

export const createNewRelation = async ({
  request,
  subjectConceptId,
  objectConcept,
  predicate = 'synonym',
}: CreateNewRelation): Promise<ApiConceptRelation | null> => {
  const response = await postConceptRelations({
    request,
    conceptId: subjectConceptId,
    conceptRelations: [
      {
        object_concept: objectConcept,
        predicate,
      },
    ],
  });
  return response ? response[0] : null;
};
